import "./Errors.css";

import React from "react";

import notificationError from "../../../assets/imgs/notification-error.svg";

export interface Error {
  id: string;
  input: string;
  message: string;
}

const Errors = React.forwardRef<HTMLDivElement, { errors: Error[] }>(
  ({ errors }, ref) => {
    return (
      <div className="Errors" ref={ref}>
        <div className="Errors__heading">
          <img src={notificationError.src} alt="Exclamation Mark" />
          <h3>Oops, there was a problem</h3>
        </div>

        <ul className="Errors__list">
          {errors.map((error) => (
            <li className="Errors__item" key={error.id}>
              {error.message}
              {error.id === "USER_EXISTS_ERROR" && (
                <span>
                  <span> Please </span>
                  <a className="hyperlink" href="/login/">
                    login here
                  </a>
                </span>
              )}
              {["RECAPTCHA_ERROR", "NETWORK_ERROR", "DEFAULT_ERROR"].includes(
                error.id,
              ) && (
                <span>
                  <span> Please </span>
                  <a
                    className="hyperlink"
                    href="https://support.sparkol.com/knowledge/kb-tickets/new"
                  >
                    contact customer support.
                  </a>
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  },
);

export default Errors;
